<script setup>
defineProps({
  name: {
    type: String,
    default: undefined,
  },
  iconName: {
    type: String,
    default: undefined,
  },
  items: {
    type: Array,
    default: () => [],
  },

  showStations: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['selectStation']);

function selectStation(station) {
  emit('selectStation', station);
}
</script>

<template>
  <div class="ui-station-group">
    <div v-if="name" class="ui-station-group__head">
      <div class="ui-station-group__name">
        <span class="ui-station-group__font">
          {{ name }}
        </span>
      </div>

      <CIcon :name="iconName" class="ui-station-group__icon" />
    </div>

    <ListsCityStations
      v-for="(item, index) in items"
      :id="item.id"
      :key="index"
      class="ui-station-group__item"
      :name="item.name"
      :original-name="item.original"
      :country="item.country"
      :stations="item.stations"
      :show-stations="showStations"
      :location-type="item.locationType"
      :city-id="item.cityId"
      @click="selectStation"
    />
  </div>
</template>

<style scoped lang="scss">
.ui-station-group {
  &__font {
    font-size: em(24);
    font-weight: 500;
    line-height: math.div(28, 24);
  }

  &__icon {
    @include box(em(28));

    color: $color-gray-3;
  }

  &__head {
    display: flex;
    align-items: center;
    padding: 0 em(12);
    margin-bottom: em(4);
  }

  &__name {
    margin-right: em(8);
    color: $color-text;
  }

  &__item {
    width: 100%;

    &:not(:last-child) {
      border-bottom: 1px solid $color-gray-3;
    }
  }
}
</style>
